export const isGuestCheckoutAvailable = (category?: string): boolean =>
  category !== "DLI";
